<template>
  <more-info-section :title="title">
    <slot />
    <h3 class="heading -quaternary">Very Low</h3>
    <h3 v-show="showCalories" class="heading -quinary -caps calorie-range">1250-1500 Calories</h3>
    <p>mostly sedentary, below average frame, low muscle mass</p>

    <h3 class="heading -quaternary">Low</h3>
    <h3 v-show="showCalories" class="heading -quinary -caps calorie-range">1500-1750 Calories</h3>
    <p>some light activity, below average frame, low muscle mass</p>

    <h3 class="heading -quaternary">Medium-Low</h3>
    <h3 v-show="showCalories" class="heading -quinary -caps calorie-range">1750-2000 Calories</h3>
    <p>
      light activity a few times a week, below average to average frame, low to average muscle mass
    </p>

    <h3 class="heading -quaternary">Medium</h3>
    <h3 v-show="showCalories" class="heading -quinary -caps calorie-range">2000-2250 Calories</h3>
    <p>light activity a few times a week, average frame, average muscle mass</p>

    <h3 class="heading -quaternary">Medium-High</h3>
    <h3 v-show="showCalories" class="heading -quinary -caps calorie-range">2250-2500 Calories</h3>
    <p>
      moderate activity a few to most days of the week, average to above average frame, average to
      above average muscle mass
    </p>

    <h3 class="heading -quaternary">High</h3>
    <h3 v-show="showCalories" class="heading -quinary -caps calorie-range">2500-2750 Calories</h3>
    <p>
      moderate to heavy activity most days of the week, average to above average frame, average to
      above average muscle mass
    </p>

    <h3 class="heading -quaternary">Very High</h3>
    <h3 v-show="showCalories" class="heading -quinary -caps calorie-range">2750-3000 Calories</h3>
    <p>
      heavy activity most days of the week, average to above average frame, average to above average
      muscle mass
    </p>

    <h3 class="heading -quaternary">Extra High</h3>
    <h3 v-show="showCalories" class="heading -quinary -caps calorie-range">3000-3500 Calories</h3>
    <p>
      extremely heavy physical activity most or every day of the week, physically demanding job
      and/or focused athletic training, average to above average frame, average to above average
      muscle mass
    </p>
  </more-info-section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import MoreInfoSection from './more-info-section.vue'

/**
 * Static content for calorie ranges
 */
export default defineComponent({
  name: 'CalorieMoreInfo',
  components: {
    MoreInfoSection,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    showCalories: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },

  computed: {},

  methods: {},
})
</script>
